

<template>
  <div>
    <h2>
Before continue and in order to better assist you...</h2>
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/question.svg" width="100%">
      </div>
    </div>

    <div v-if="questions != null && values != null && errorMessages != null">
      <why-form v-if="questions != null && values != null && errorMessages != null" ref="userForm"
      :questions="questions"
      :values="values"
      :error-messages="errorMessages"
      >
     </why-form>
    </div>

  

    <div class="centered-child" style="margin-top: 48px">
      <md-button class="md-raised md-primary large-button" @click="onClickValidate()">Confirm</md-button>
    </div>

  </div>

</template>

<script>
import WhyForm from '../components/PaymentWhyForm'
import ServiceAccess from '../service/ServiceAccess'

export default {
  components: {
    'why-form': WhyForm
  },

  data: function () {
    return {
      questionIds: ['id_why_no_cb'],
      questions: null,
      errorMessages: null,
      values: null,
      userFormHasError: false
    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadErrorMessages(),
      ServiceAccess.instance.loadQuestions()
    ]
    Promise.all(promises).then(responses => {
      let [values, errorMessages, questions] = responses
      this.values = values
      this.questions = questions
      this.errorMessages = errorMessages
      this.$forceUpdate()
    })
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      this.$router.back()
    },


    onClickValidate: function () {
      let qid = this.questionIds[0]
      let v = this.values[qid]
      let texts = v.map(i => this.questions[qid].a.values[i].en)
      ServiceAccess.instance.track(this.$route.params.sessionId, 'payment-why', {values: texts})

      ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)
      this.$router.push('/f/' + this.$route.params.sessionId + '/' + this.$route.params.medium + '/' + this.$route.params.cart)
    }

  }
}
</script>



// WEBPACK FOOTER //
// CheckoutPaymentWhy.vue?fe2f9466